// extracted by mini-css-extract-plugin
export default {"change-email-modal":"ChangeEmailModal_change-email-modal__tre0W"};